import { NgClass } from '@angular/common';
import { Component, OnInit, input, signal } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'ui-avatar',
  standalone: true,
  imports: [NgClass],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {
  readonly src = input<string | SafeUrl>();
  readonly alt = input<string>('');
  readonly name = input<string>('');
  readonly size = input<'sm' | 'md' | 'lg' | 'xl' | '2xl'>('md');
  readonly variant = input<'circle' | 'square'>('circle');

  readonly initials = signal<string>('');
  readonly image = signal<string | SafeUrl | null>(null);

  ngOnInit(): void {
    this.initials.set(this.getInitials());

    if (this.src()) {
      this.image.set(this.src());
    }
  }

  onError(): void {
    this.image.set(null);
  }

  private getInitials(): string {
    if (!this.name) {
      return '';
    }

    const [firstName, ...lastNames] = this.name().split(' ');

    if (!lastNames.length) {
      return firstName.length > 1
        ? `${firstName.charAt(0).toUpperCase()}${firstName
            .charAt(1)
            .toUpperCase()}`
        : firstName.charAt(0).toUpperCase();
    }

    const lastName = lastNames[lastNames.length - 1];

    return `${firstName.charAt(0).toUpperCase()}${lastName
      .charAt(0)
      .toUpperCase()}`;
  }
}
